import { getIconProps, type IconProps } from '#types'

/**
 * Loader / spinner icon — use with `animate-spin` for a spinning indicator.
 */
export function LoaderIcon(props: IconProps) {
  return (
    <svg
      {...getIconProps(props)}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path d="M20.2419 11.1299C20.6559 11.1299 21 11.4561 21 11.8701C20.9998 17.7828 18.1665 20.7393 12.5 20.7393C8.29538 20.7393 5.65134 19.1112 4.56663 15.8558C4.3931 15.335 4.8052 14.8262 5.35415 14.8262H6.166C6.19352 14.8262 6.21582 14.8039 6.21582 14.7764C6.21582 14.7162 6.31344 14.7054 6.32872 14.7636C6.60527 15.8169 7.03984 16.5852 7.56934 17.1377C8.48234 18.0903 9.99723 18.7393 12.5 18.7393C15.0028 18.7393 16.5177 18.0903 17.4307 17.1377C18.3588 16.1692 18.9999 14.5388 19 11.8701C19 11.467 19.318 11.1299 19.721 11.1299H20.2419ZM12.5 3C16.62 3 19.2416 4.56314 20.366 7.68902C20.5875 8.30491 20.0952 8.91309 19.4407 8.91309C18.977 8.91309 18.5798 8.59856 18.4082 8.16789C18.148 7.51507 17.8141 7.00173 17.4307 6.60156C16.5177 5.6489 15.0028 5 12.5 5C9.9972 5 8.48234 5.6489 7.56934 6.60156C6.64116 7.57015 6 9.2012 6 11.8701C6.00001 12.2721 5.68294 12.6084 5.28092 12.6084H4.75613C4.34325 12.6084 4.00001 12.283 4 11.8701C4 6.14168 6.65918 3.18764 11.9775 3.00879L12.5 3Z" fill="currentColor"/>
      <path d="M20.261 3.73914V8.17392H15.8262" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.73905 20L4.73905 15.5652L9.17383 15.5652" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
